<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#chevron-down__a)">
    <path d="M21.735 5.209a1 1 0 0 0-1.416 0L12 13.543 3.68 5.209a1 1 0 0 0-1.415 0L.705 6.772a1 1 0 0 0 0 1.413l10.587 10.606a1 1 0 0 0 1.416 0L23.295 8.185a1 1 0 0 0 0-1.413l-1.56-1.563Z"/>
  </g>
  <defs>
    <clipPath id="chevron-down__a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
